import useEmits from "./useEmits";

export default [useEmits]
